module.exports = __webpack_public_path__ + "assets/profile.7e14caf7.svg";